import {
  Client,
  SelectedSubproject,
  Subproject,
  BaseAccount,
  AccountRights,
  Module,
  Project,
  ColorType,
  UserPreferences,
  CustomDataOperator,
} from '.';
import { ClientSupport } from './client-support.model';

export interface UserSession extends BaseAccount, AccountRights {
  accountId: string;
  subprojects: Subproject[];
  projects: Project[];
  colorTypes: ColorType[];
  customDataOperators: CustomDataOperator[];
  clientsList: Client[];
  clientSupport: ClientSupport;
  userPreferences: UserPreferences;
  termsConditionsAccepted: boolean;
  selectedClientId: string;
  modules: Module[];
  selectedSubproject?: SelectedSubproject;
  selectedSubprojectId?: number;
}
